import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AUTH_PREFIX_PATH,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
} from "configs/AppConfig";

const ProtectedRoute = () => {


	
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();
  const storedToken = localStorage.getItem("auth_token");
  const isLoginPage = location.pathname === '/auth/login';
  if (!storedToken && !isLoginPage) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
